import React, { Component } from "react";
import {
	Loading,
	Button,
	Tabs,
	Tab,
	HeaderName,
	HeaderNavigation,
	SkeletonText,
	TableToolbar,
	Search,
	TextInput,
	Table,
	DatePickerInput,
	DatePicker,
	StructuredListCell,
	StructuredListBody,
	Toggle,
	ToggleSmall,
	ModalWrapper,
	StructuredListHead,
	StructuredListRow,
	Form,
	Accordion,
	AccordionItem,
	DataTable,
	StructuredListWrapper,
	TableContainer,
	TableHead,
	TableHeader,
	TableBody,
	TableRow,
	TableCell,
	Checkbox,
	FormLabel,
	FileUploader,
	RadioButtonGroup,
	FormGroup,
	MultiSelect,
	RadioButton,
	TextArea,
	TimePicker,
	TimePickerSelect,
	ComposedModal,
	ModalHeader,
	ModalBody,
	SelectItem,
	ModalFooter,
} from "carbon-components-react";
import { ScrollingProvider, Section } from "../../lib/react-scroll-section/src/index";
import { Menu, Item } from "../../helpers/scrolling/ScrollingMenuItem";
import "../../scss/custom.scss";
import "../../scss/react-datetime.css";
import { switchDateFormat } from "../../helpers/jsonschemaform/customwidget/utils";
import { ComboBox } from "../../helpers/ComboBox";
import { showNotification } from "../../helpers/notification/BaseNotification";
import { getSuccess, getError, entitiesLabels, apioperation, STATUS, DateFormat } from "../../helpers/Constants";
import { api, dynamic, registry, me, training } from "../../helpers/api/api";
import { IsInRole, IsEditable, CanExecuteAction } from "../../helpers/authorization/Policies";
import { AppContext } from "../../helpers/context/AppContext";
import { CheckmarkOutline16, Send16, Delete16, Error16, Checkmark24, Information16, Add16, Edit16, CertificateCheck16, PaintBrushAlt16, Download16, Export16 } from "@carbon/icons-react/lib/";
import { WFActionModal } from "../common/WFActionModal";
import PageBreadCrumb from "../../helpers/PageBreadCrumb";
import { HistoryTable } from "../../helpers/HistoryTable";
import SimpleReactValidator from "simple-react-validator";
import { Online, Offline } from "../common/OnLineOffLine";
import moment from "moment";
import DateTimePicker from "../../helpers/DateTimePicker";
import { NoRecordsPlaceholder } from "../../helpers/jsonschemaform/DataTableExtention";
import { v4 as uuid } from "uuid";
import _sortBy from "lodash/sortBy";
import { ConfirmAlertCustom } from "../../helpers/ConfirmAlertCustom";
import ModalParticipant from "./ModalParticipant";
import ModalContent from "./ModalContent";
import ModalTrainer from "./ModalTrainer";
import ModalSignature from "./ModalSignature";
import ModalSignatureParticipant from "./ModalSignatureParticipant";
import TrainingRepository from "../../helpers/api/TrainingRepository";
import FileDownLoadButton from "../common/FileDownloadButton";
import AttachmentTable, { attachmentTablePrivacyText } from "../common/AttachmentTable";
import ConfirmModal from "../common/ConfirmModal";

const TrainingAttachmentTableMainDescription = "Upload only one file at 3 Mb or less; please check the file attached before to submit the report because afterwards it is not possible to modify it"
export class NewTraining extends Component {
	baseUrl;
	constructor(props) {
		super(props);

		let idTraining = this.props.match.params.id;

		this.state = {
			idTraining,
			isLoadingTraining: idTraining != undefined,
			isEdit: idTraining != undefined,
			model: {
				...this.initModel(),
			},
			isSubmitted: false,
			isDisabled: false,

			invalidCertifiedDuration: false,
			///Status Action
			isLoadingNotificationFile: false,
			isApprovalModalOpen: false,
			approvalModalAction: "",
			approver: null,
			approvalStartDate: null,
			approvalEndDate: null,
			isLoadingApproverOptions: true,
			approvalValidationMessages: [],
			approvers: [],
			selectedData: [],
			approverRole: "",
			withApprover: true,
			isLoadingWFOperation: false,
			approvalNotesRequired: false,
			///Status Action
			//History WF
			isHistoryModalOpen: false,
			//History WF

			///Modal Content
			keyModalContent: `modalContent_${new Date().getTime()}`,
			isOpenModalContent: false,
			idToEditContent: null,
			idToDeleteContent: null,
			///fine Modal
			///Modal Participant
			keyModalParticipant: `modalParticipant_${new Date().getTime()}`,
			isOpenModalParticipant: false,
			idToEditParticipant: null,
			idToDeleteParticipant: null,
			///fine Modal
			///Modal Trainer
			keyModalTrainer: `modalTrainer_${new Date().getTime()}`,
			isOpenModalTrainer: false,
			idToDeleteTrainer: null,
			///fine Modal
		};

		this.baseUrl = "/training/";
		this.originalValidityDate = null;

    this.gtzValidator = {
      message: 'The value must be greater than zero',
      rule: (val) => {
        return +val > 0;
      }
    };
		this.validator = new SimpleReactValidator({
			validators: { gtz: this.gtzValidator }
		});
		this.updateState = this.updateState.bind(this);
	}

	initModel = () => {
		let model = {
			//-----campi form------------
			id: uuid(), //guid
			startDate: null, //date
			endDate: null, //date
			certificateValidityMonths: null, //number
			validityDate: null, //date
			idCountry: null, //guid
			idDivision: null, //guid  division del worksite da valorizzare quando si sceglie il worksite
			idLanguage: null, //guid
			idMethod: null, //guid
			idProject: null, //guid
			idTrainingAssessmentMethod: null, //guid
			specifyOtherAssessmentMethod: null,
			idTrainingData: null, //guid
			idWorkSite: null, //guid
			remedialActionsForFailure: null, //string
			idTrainingCenter: null, //guid
			idTrainer: null, //guid
			trainer: null, //{} TrainerDTO
			trainingContents: [], //[] TrainingContentDTO
			trainingParticipant: [], //[] TrainingParticipantDTO
			certifiedDuration: null,

			//-----campi di visualizzazione/sistema------------
			idCompiler: null, //guid
			idDataApprover: null, //guid
			idDivisionManager: null, //guid
			compiler: null, //string
			dataApprover: null, //string
			divisionManager: null, //string
			code: null, //string BE "TRA_1",
			progressiveId: undefined, //int BE
			sequence: undefined, //int BE
			idStatus: 0, //int
			status: null, //string "Draft",
			country: null, //string
			language: null, //string
			method: null, //string
			project: null, //string
			trainingAssessmentMethod: null, //string
			workSite: null, //string
			workflowNotes: null, //string
			info: null, //{} TrainingDataDTO solo per visualizzazione, non usato lato BE

			//download template & massive import
			downloadTemplateLoading: false,
			isImportTemplateModalOpen: false,
			//---------------------------

			// RITM0562378
			attachments: []
		};
		return model;
	};

	componentDidMount() {
		this.getCountry();
		this.getAllWorkSite();
		this.getAllWorkSitePrj();
		this.getTrainingData();
		this.getTrainingLanguage();
		this.getTrainingMethod();
		this.getTrainingAssessmentMethod();
		this.getTrainingCenters();
		this.getInfoOriginator();

		if (this.state.idTraining != undefined) {
			this.getTraining(this.state.idTraining);
		}
	}

	////----------handleChange----------------
	updateState = (inputName, inputValue, objName) => {
		let statusCopy = Object.assign({}, this.state[objName]);
		statusCopy[inputName] = inputValue;

		if(inputName ==="certifiedDuration" && this.checkValidHours(inputValue)) this.setState({ [objName]: statusCopy, invalidCertifiedDuration: false })
		else this.setState({ [objName]: statusCopy });
	};

	handleChangeCertificateValidityPeriod = (e) => {
		const isEmptyOrWhiteSpace = (str) => {
			return str == null || str.match(/^ *$/) !== null;
		};
		const rawValue = e.target.value;
		const value = isEmptyOrWhiteSpace(rawValue) ? null : parseInt(rawValue);
		if (isNaN(value)) return;
		this.setState(prevState => {
      let modelCopy = { ...prevState.model };
      modelCopy.certificateValidityMonths = value;
      modelCopy.validityDate = value == null
        ? this.originalValidityDate
        : moment(modelCopy.endDate)
            .add(value, 'month')
            .format("YYYY-MM-DD");
			return {
				model: modelCopy
			};
		});
	};

	handleChangeModel = (el) => {
		let inputName = el.target.name;
		let inputValue = el.target.value;
		let objName = el.target.alt;
      this.updateState(inputName, inputValue, objName);
	};

	handleChangeDate = (inputName, inputValue, objName) => {
		//(inputName == 'startDate' || inputName == 'endDate')
		let statusCopy = Object.assign({}, this.state[objName]);
		statusCopy[inputName] = inputValue;

		statusCopy.idWorkSite = null;
		statusCopy.workSite = null;
		statusCopy.idDivision = null;
		statusCopy.idProject = null;
		statusCopy.project = null;
		statusCopy.idTrainingData = null
		statusCopy.info = null
		statusCopy.certifiedDuration = null

		if(inputName === "endDate"){
			if (statusCopy.certificateValidityMonths != null) {
				const certificateValidityMonths = parseInt(statusCopy.certificateValidityMonths)
        statusCopy.validityDate = !isNaN(certificateValidityMonths)
					? moment(statusCopy.endDate)
              .add(statusCopy.certificateValidityMonths, 'month')
              .format("YYYY-MM-DD")
					: null
      }
		}

		this.setState({ [objName]: statusCopy });
	};

	handleChangeCombo = (inputName, selectedItem, objName) => {
		let inputValue = selectedItem ? selectedItem.id : null;

		let statusCopy = Object.assign({}, this.state[objName]);
		statusCopy[inputName] = inputValue;

		if (inputName == "idWorkSite") {
			statusCopy.workSite = selectedItem ? selectedItem.name : null;
			statusCopy.idDivision = selectedItem ? selectedItem.idDivision : null;
			statusCopy.idProject = null;
			statusCopy.project = null;
			//devOps 639
			statusCopy.idCountry = null;
			statusCopy.country = null;

		}

		if (inputName == "idProject") {
			statusCopy.project = selectedItem ? selectedItem.name : null;
			//devOps 639
			statusCopy.idCountry = selectedItem ? selectedItem.idCountry : null
			statusCopy.country = this.state.appCountry.find(el => el.id === selectedItem?.idCountry)?.name ?? null
		}

		if (inputName == "idTrainingData") {
			statusCopy.info = selectedItem;
			statusCopy.certifiedDuration = selectedItem?.duration;
		}
		if (inputName == "idLanguage") {
			statusCopy.language = selectedItem ? selectedItem.name : null;
		}
		if (inputName == "idCountry") {
			statusCopy.country = selectedItem ? selectedItem.name : null;
		}
		if (inputName == "idMethod") {
			statusCopy.method = selectedItem ? selectedItem.name : null;
		}
		if (inputName == "idTrainingAssessmentMethod") {
			statusCopy.trainingAssessmentMethod = selectedItem ? selectedItem.name : null;
		}

		this.setState({ [objName]: statusCopy });
	};

	////----------Fine handleChange----------------

	showLoading() {
		let show = (this.state.isEdit && this.state.isLoadingTraining) || this.state.isSubmitted;
		let descr = this.state.isSubmitted ? "Saving..." : "Loading data...";
		return show && <Loading active={true} withOverlay={true} description={descr} />;
	}

	showButtonHistory = () => {
		return (
			<Online>
				<Button className="action-button-modal" kind="secondary" renderIcon={Information16} onClick={() => this.openModalHistory()}>
					History
				</Button>
			</Online>
		);
	};

	openModalHistory = () => {
		this.setState({ isHistoryModalOpen: true });
	};

	closeModalHistory = () => {
		this.setState({ isHistoryModalOpen: false });
	};

	cancel = () => {
		this.props.history.push("/training");
	};

	toggleModal = (open, property) => {
		this.setState({ [property]: open });
	};

	getPrj = (idWorkSite, start, end) => {
		try {
			let data = (this.state.appAllWorksitePrj || []).filter((el) => el.idWorkSite == idWorkSite);

			if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(start) && /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(end)) {
				data = (data || []).filter((el) => el.start <= start && end <= el.end);
				return _sortBy(
					data.map((item) => ({ id: item.idProject, name: item.project, idWorksitePrj: item.id, /*devOps 639*/ idCountry: item.idCountry })),
					"name"
				);
			} else {
				return null;
			}
		} catch {
			showNotification.error(`${entitiesLabels.ERROR}`, "Error filtering " + entitiesLabels.WORKSITEPROJECT);
			return null;
		}
	};

	getWorkSite = (start, end) => {
		try {
			let data = this.state.appAllWorksites;

			if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(start) && /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(end)) {
				return (data || []).filter((el) => el.start <= start && end <= el.end);
			} else {
				return null;
			}
		} catch {
			showNotification.error(`${entitiesLabels.ERROR}`, "Error filtering " + entitiesLabels.WORKSITE);
			return null;
		}
	};

	////----------API----------------
	getAllWorkSite() {
		api.getAll("/me/worksites")
			.then((response) => {
				let data = response.data;
				this.setState({
					appAllWorksites: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITE, apioperation.GET));
			})
			.finally(() => {});
	}

	getAllWorkSitePrj() {
		api.getAll("/me/worksitesproject")
			.then((response) => {
				let data = response.data;
				this.setState({
					appAllWorksitePrj: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITEPROJECT, apioperation.GET));
			})
			.finally(() => {});
	}

	getInfoOriginator = () => {
		registry
			.getAll("infooriginator")
			.then((response) => {
				let data = response.data.filter(item => item.name != "Saipem");
				data = data != null ? data.map((item) => ({ id: item.name, name: item.name })) : [];
				this.setState({
					appInfoOriginator: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INFOORIGINATOR, apioperation.GET));
			})
			.finally(() => {});
	};

	getCountry = () => {
		api.getAll("/country")
			.then((response) => {
				let data = response.data;
				this.setState({
					appCountry: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.COUNTRY, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingCountry: false,
				});
			});
	};

	returnValidTrainingData = (itemList) => {
		if (itemList) {
			// return  itemList.filter((el) => el.inUse);
			const selectedStartDate = new Date(this.state.model.startDate)
			const startedTrainings = itemList.filter((el) => (el.validSince ? new Date(el.validSince) <= selectedStartDate : true)) ?? [];
			const startedNotExpired = startedTrainings.filter((el) => (el.validUntil ? new Date(el.validUntil) >= selectedStartDate : true)) ?? [];
			
			return startedNotExpired
		}
		return [];
	};

	getTrainingData = () => {
		dynamic
			.getAll("trainingdata", { params: { page: 0 } })
			.then((response) => {
				let data = response.data.itemList;
				this.setState({
					appTrainingData: _sortBy(data, "courseCode"),
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGDATA, apioperation.GET));
			})
			.finally(() => {});
	};

	getTrainingLanguage = () => {
		dynamic
			.getAll("traininglanguage", { params: { page: 0 } })
			.then((response) => {
				let data = response.data.itemList;
				this.setState({
					appLanguage: data,
					//devOps 638
					model: {
						...this.state.model,
						idLanguage: this.state.idTraining != undefined ? this.state.model.idLanguage : data.find(el => el.code.toUpperCase() ==="ENGLISH")?.id ?? null
					}
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGLANGUAGE, apioperation.GET));
			})
			.finally(() => {});
	};

	getTrainingMethod = () => {
		dynamic
			.getAll("trainingmethod", { params: { page: 0 } })
			.then((response) => {
				let data = response.data.itemList;
				this.setState({
					appMethod: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGMETHOD, apioperation.GET));
			})
			.finally(() => {});
	};

	getTrainingAssessmentMethod = () => {
		dynamic
			.getAll("trainingassessmentmethod", { params: { page: 0 } })
			.then((response) => {
				let data = response.data.itemList;
				this.setState({
					appAssessmentMethod: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGASSESSMENTMETHOD, apioperation.GET));
			})
			.finally(() => {});
	};

	getTrainingCenters = () => {
		dynamic
			.getAll("trainingcenter", { params: { page: 0 } })
			.then((response) => {
				let data = response.data.itemList.filter(item => item.inUse === true); //RITM0837173
				this.setState({ appTrainingCenters: data });
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGCENTER, apioperation.GET));
			})
			.finally(() => { });
	};

	getTraining(id) {
		this.setState({
			isEdit: true,
			isLoadingTraining: true,
		});

		api.get(this.baseUrl, id)
			.then((response) => {
				let data = response.data;
				if (data) {
					this.originalValidityDate = data.validityDate ?? null;
					this.setState({
						model: data,
						isDisabled: data ? !IsEditable("Training", "Reporting", this.context.user, data.idStatus, "All", data) : false,
					});
				} else {
					showNotification.error();
					this.cancel();
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAINING, apioperation.GET));

				this.cancel();
			})
			.finally(() => {
				this.setState({
					isLoadingTraining: false,
				});
			});
	}

	saveTraining = () => {
		const validDuration =  this.checkValidHours(this.state.model.certifiedDuration)
		if (this.validator.allValid() && validDuration) {
			this.toggleModal(true, "isSubmitted");

			let datiForm = this.state.model;

			//if (!this.state.isEdit) { datiForm.id = uuid() } spostato in initModel
			let method = this.state.isEdit ? api.put(this.baseUrl, datiForm, datiForm.id) : api.post(this.baseUrl, datiForm);

			method
				.then((response) => {
					if (response.status == 200) {
						let resp = response.data;

						showNotification.success(`${entitiesLabels.SUCCESS}`, this.state.isEdit ? getSuccess(entitiesLabels.TRAINING, apioperation.PUT) : getSuccess(entitiesLabels.TRAINING, apioperation.POST));

						if (!this.state.isEdit) {
							//aggiornare il modello dati con le props mancanti
							datiForm["idCompiler"] = this.context.user.id;
							datiForm["compiler"] = this.context.user.email;
							datiForm["idStatus"] = 1;
							datiForm["status"] = "Draft";
						}

						//update new default validity date
						this.originalValidityDate = this.state.model.validityDate;

						//update state partecipants for enable signature
						if (datiForm.trainingParticipant && datiForm.trainingParticipant.length) {
							let newtrainingParticipants = [...datiForm.trainingParticipant];
							newtrainingParticipants.forEach(function (obj) {
								if (obj.toSave) {
									obj.toSave = false;
								}
							});
							this.updateState("trainingParticipant", newtrainingParticipants, "model");
						}

						this.updateCacheTrainingModel(datiForm);
					} else {
						showNotification.error();
					}
				})
				.catch((error) => {
					showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAINING, apioperation.POST));
				})
				.finally(() => {
					this.toggleModal(false, "isSubmitted");
				});
		} else {
			this.validator.showMessages();
			showNotification.warning(`${entitiesLabels.WARNING}`, entitiesLabels.TRAINING + " required fields are missing  ");
			if(!validDuration){
				this.setState({invalidCertifiedDuration: true})
				showNotification.warning(`Certified Duration Not Valid`, "Only integer or decimal values ​​greater than 0 and with a scale of 0.5 are allowed")
			} 
			this.forceUpdate();
		}
	};

	updateCacheTrainingModel = async (datiForm) => {
		await Promise.all([TrainingRepository.updateCachedTrainingList(datiForm), TrainingRepository.updateCachedTraining(datiForm.id, datiForm)])
			.then((response) => {
				if (!this.state.isEdit) {
					this.props.history.push("/training/");
				}
			})
			.catch((error) => {
				console.error({ error });
			})
			.finally(() => {});
	};

	////----------Fine API----------------

	/**************Contents**********************/

	addContent = () => {
		this.setState({
			isOpenModalContent: true,
			idToEditContent: null,
			keyModalContent: `modalContent_${new Date().getTime()}`,
		});
	};

	editContent = (id) => {
		this.setState({
			isOpenModalContent: true,
			idToEditContent: id,
			keyModalContent: `modalContent_${new Date().getTime()}`,
		});
	};

	handleSaveModalContent = (data) => {
		try {
			if (data == null) return;

			let oldtrainingContents = this.state.model.trainingContents || [];

			if (this.state.idToEditContent != null) {
				//edit
				let id = data.id;
				let indexElement = oldtrainingContents.findIndex((el) => el.id == id);
				if (indexElement > -1) {
					let newtrainingContents = [...oldtrainingContents];
					newtrainingContents[indexElement] = data;
					this.updateState("trainingContents", newtrainingContents, "model");
				} else {
					showNotification.error();
				}
			} else {
				//insert
				data.id = uuid();
				data.createdOn = moment.utc().format();
				data.createdBy = this.context.user.email;
				let newtrainingContents = oldtrainingContents.concat([data]);
				this.updateState("trainingContents", newtrainingContents, "model");
			}

			this.setState({ isOpenModalContent: false });
		} catch (error) {
			showNotification.error();
		}
	};

	confirmDeleteContent = (id) => {
		this.setState({
			idToDeleteParticipant: null,
			idToDeleteTrainer: null,
			idToDeleteContent: id,
			isOpenDeleteModal: true,
			isDeleting: false,
		});
	};

	deleteItemContent = () => {
		let id = this.state.idToDeleteContent;
		this.setState({
			isDeleting: true,
		});

		let statusCopy = Object.assign({}, this.state.model);
		statusCopy.trainingContents = statusCopy.trainingContents.filter((el) => el.id !== id);

		this.setState({
			model: statusCopy,
			isDeleting: false,
			isOpenDeleteModal: false,
		});
	};

	/**************Fine Contents**********************/
	/**************Participants**********************/

	addParticipant = () => {
		this.setState({
			isOpenModalParticipant: true,
			idToEditParticipant: null,
			keyModalParticipant: `modalParticipant_${new Date().getTime()}`,
		});
	};

	editParticipant = (id) => {
		this.setState({
			isOpenModalParticipant: true,
			idToEditParticipant: id,
			keyModalParticipant: `modalParticipant_${new Date().getTime()}`,
		});
	};

	handleSaveModalParticipant = (data) => {
		try {
			if (data == null) return;

			let oldtrainingParticipants = this.state.model.trainingParticipant || [];

			if (this.state.idToEditParticipant != null) {
				//edit
				let id = data.id;
				let indexElement = oldtrainingParticipants.findIndex((el) => el.id == id);
				if (indexElement > -1) {
					let newtrainingParticipants = [...oldtrainingParticipants];
					//newtrainingParticipants[indexElement] = data;
					newtrainingParticipants[indexElement].type = data.type;
					newtrainingParticipants[indexElement].name = data.name;
					newtrainingParticipants[indexElement].surname = data.surname;
					newtrainingParticipants[indexElement].email = data.email;
					newtrainingParticipants[indexElement].position = data.position;
					newtrainingParticipants[indexElement].badgeNumber = data.badgeNumber;
					newtrainingParticipants[indexElement].birthDate = data.birthDate;
					newtrainingParticipants[indexElement].idEmployer = data.idEmployer;

					this.updateState("trainingParticipant", newtrainingParticipants, "model");
				} else {
					showNotification.error();
				}
			} else {
				//insert
				data.id = uuid();
				data.idTraining = this.state.model.id;
				data.createdOn = moment.utc().format();
				data.createdBy = this.context.user.email;
				data.toSave = true;
				let newtrainingParticipants = oldtrainingParticipants.concat([data]);
				this.updateState("trainingParticipant", newtrainingParticipants, "model");
				this.setState({
					search: null,
				});
			}

			this.setState({ isOpenModalParticipant: false });
		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAINING, apioperation.POST));
		}
	};

	confirmDeleteParticipant = (id) => {
		this.setState({
			idToDeleteContent: null,
			idToDeleteTrainer: null,
			idToDeleteParticipant: id,
			isOpenDeleteModal: true,
			isDeleting: false,
		});
	};

	deleteItemParticipant = () => {
		let id = this.state.idToDeleteParticipant;
		this.setState({
			isDeleting: true,
		});

		let statusCopy = Object.assign({}, this.state.model);
		statusCopy.trainingParticipant = statusCopy.trainingParticipant.filter((el) => el.id !== id);

		this.setState({
			model: statusCopy,
			isDeleting: false,
			isOpenDeleteModal: false,
		});
	};

	/**************Fine Participants**********************/
	/**************Trainer**********************/

	editTrainer = () => {
		this.setState({
			isOpenModalTrainer: true,
			keyModalTrainer: `modalTrainer_${new Date().getTime()}`,
		});
	};

	handleSaveModalTrainer = (data) => {
		try {
			if (data == null) return;

			if (!this.state.model.trainer) {
				//insert
				data.id = uuid();
				data.createdOn = moment.utc().format();
				data.createdBy = this.context.user.email;
			}

			let statusCopy = Object.assign({}, this.state.model);
			statusCopy.idTrainer = data.id;
			statusCopy.trainer = { ...statusCopy.trainer, ...data };
			statusCopy.trainer.updatedOn = moment.utc().format();
			statusCopy.trainer.updatedBy = this.context.user.email;

			this.setState({
				model: statusCopy,
				isOpenModalTrainer: false,
			});
		} catch (error) {
			showNotification.error();
		}
	};

	confirmDeleteTrainer = (id) => {
		this.setState({
			idToDeleteContent: null,
			idToDeleteParticipant: null,
			idToDeleteTrainer: id,
			isOpenDeleteModal: true,
			isDeleting: false,
		});
	};

	deleteItemTrainer = () => {
		let id = this.state.idToDeleteTrainer;
		this.setState({
			isDeleting: true,
		});

		let statusCopy = Object.assign({}, this.state.model);
		statusCopy.idTrainer = null;
		statusCopy.trainer = null;

		this.setState({
			model: statusCopy,
			isDeleting: false,
			isOpenDeleteModal: false,
		});
	};

	/**************Fine Trainer**********************/
	/**************TrainerSign**********************/

	editTrainerSign = () => {
		this.setState({
			isOpenModalTrainerSign: true,
			keyModalTrainerSign: `modalTrainerSign_${new Date().getTime()}`,
		});
	};

	handleSaveModalTrainerSign = (data) => {
		try {
			if (data == null) return;

			if (this.state.model.trainer) {
				let statusCopy = Object.assign({}, this.state.model);
				statusCopy.trainer.signatureAttachment = data;
				this.setState({
					model: statusCopy,
					isOpenModalTrainerSign: false,
				});
			}
		} catch (error) {
			showNotification.error();
		}
	};

	/**************Fine TrainerSign**********************/
	/**************ParticipantsSign**********************/

	editParticipantsSign = (id) => {
		this.setState({
			isOpenModalParticipantsSign: true,
			idToEditParticipantsSign: id,
			keyModalParticipantsSign: `modalParticipantsSign_${new Date().getTime()}`,
		});
	};

	handleSaveModalParticipantsSign = (data) => {
		try {
			if (data == null) return;

			let oldtrainingParticipants = this.state.model.trainingParticipant || [];
			let id = data.id;
			let indexElement = oldtrainingParticipants.findIndex((el) => el.id == id);
			if (indexElement > -1) {
				let newtrainingParticipants = [...oldtrainingParticipants];

				newtrainingParticipants[indexElement].knowledgeAssessment = data.knowledgeAssessment;
				newtrainingParticipants[indexElement].note = data.note;
				newtrainingParticipants[indexElement].signatureAttachment = data.signatureAttachment;

				let statusCopy = Object.assign({}, this.state.model);
				statusCopy.trainingParticipant = newtrainingParticipants;
				this.setState({
					model: statusCopy,
					isOpenModalParticipantsSign: false,
				});
			} else {
				showNotification.error();
			}
		} catch (error) {
			showNotification.error();
		}
	};
	/**************Fine ParticipantsSign**********************/

	handleInputChange = (e) => {
		let val = e.target.value;
		this.setState({
			search: val,
		});
	};

	///WF
	handleApproverSelect = (selectedItem) => {
		this.setState({ approver: selectedItem });
	};
	handleCloseApprovalModal = () => {
		this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
	};
	handleApprovalNotesChange = (e) => {
		this.setState({ approvalNotes: e.target.value });
	};
	IsRowSelectable() {
		var row = this.state.model;
		if (row == null || row.idStatus == STATUS.Consolidated) return false;

		return true;
	}

	getUsersInRole = (role, idEntity) => {
		me.getWithParam("users", {
			params: { Role: role, IdEntity: idEntity, includeAdmins: true },
		})
			.then((response) => {
				this.setState({
					approvers: response.data,
					isLoadingApproverOptions: false,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.ROLE, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingApproverOptions: false,
				});
			});
	};
	handleConfirmApprovalModal = () => {
		let action = this.state.approvalModalAction?.toLowerCase();
		let apiEndpoint = this.state.approvalEndpoint;

		const data = {
			ids: [this.state.idTraining],
			owner: this.state.approver,
			workflowNotes: this.state.approvalNotes,
		};

		this.setState({
			isLoadingWFOperation: true,
		});
		api.put("/training/" + apiEndpoint, data, "")
			.then((response) => {
				if (response.status === 200) {
					showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.TRAINING, apioperation.PUT));
					this.setState({
						isLoadingWFOperation: false,
						isApprovalModalOpen: false,
						isLoading: true,
					});
					this.props.history.push("/training");
				} else {
					showNotification.error();
					this.setState({
						isLoadingWFOperation: false,
					});
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAINING, apioperation.PUT));
				this.setState({
					isLoadingWFOperation: false,
				});
			})
			.finally(() => {});
	};
	batchActionClick(actionKey, actionName, approverRole, withApprover, approvalNotesRequired, selectedRows) {
		var training = this.state.model;

		var idEntity = actionKey == "Submit" ? training.idWorkSite : actionKey == "Approve" ? training.idDivision : null;

			this.setState({
				approvalModalAction: actionName,
				isApprovalModalOpen: true,
				isLoadingApproverOptions: true,
				withApprover: withApprover,
				selectedData: selectedRows,
				approverRole: approverRole,
				approvalEndpoint: actionKey,
				approvalNotesRequired: approvalNotesRequired,
			});
			
		if (withApprover) this.getUsersInRole(approverRole, idEntity);
	}

	getStatusActions = (user) => {
		if (!this.IsRowSelectable()) return null;

		const idStatus = this.state.model.idStatus;
		return (
			<Online>
				{CanExecuteAction("Training", "Reporting", user, idStatus, "Submit", this.state.model) ? (
					<Button renderIcon={Send16} onClick={() => this.batchActionClick("Submit", "Submit", "Data Approver", true, false, null)}>
						Submit Report
					</Button>
				) : null}
				{/* RITM0565449 */}
				{CanExecuteAction("Training", "Reporting", user, idStatus, "Approve", this.state.model) ? (
					<Button renderIcon={CheckmarkOutline16} onClick={() => this.batchActionClick("Approve", "Approve", "null", false, false, null)}>
						Approve Report
					</Button>
				) : null}
				{/* FINE RITM0565449 */}

				{CanExecuteAction("Training", "Reporting", user, idStatus, "Consolidate", this.state.model) ? (
					<Button renderIcon={CheckmarkOutline16} onClick={() => this.batchActionClick("Consolidate", "Consolidate", null, false, false, null)}>
						Consolidate Report
					</Button>
				) : null}

				{CanExecuteAction("Training", "Reporting", user, idStatus, "Reject", this.state.model) ? (
					<Button renderIcon={Error16} onClick={() => this.batchActionClick("Reject", "Reject", null, false, true, null)}>
						Reject Report
					</Button>
				) : null}

				{CanExecuteAction("Training", "Reporting", user, idStatus, "RejectConsolidate", this.state.model) ? (
					<Button renderIcon={Error16} onClick={() => this.batchActionClick("RejectConsolidate", "Reject", null, false, true, null)}>
						Reject Report
					</Button>
				) : null}

				{CanExecuteAction("Training", "Reporting", user, idStatus, "Delete", this.state.model) ? (
					<Button renderIcon={Delete16} onClick={() => this.batchActionClick("Delete", "Delete", null, false, false, null)}>
						Delete
					</Button>
				) : null}
			</Online>
		);
	};
	///fine WF
	showDownloadSingleCert = (item) => {
		//visualizzo il pulsante download certificato sul singolo partecipante

		if (!this.state.isEdit || item.toSave) return false; //training o partecipante non salvato sul db

		if (this.state.model == null || this.state.model.info == null) return false;

		return item.knowledgeAssessment == "Pass";
		
	};

	renderParticipants(isSaipem, participants) {
		let trainingParticipants = isSaipem ? (participants || []).filter((el) => el.type.toLowerCase() == "saipem" ) : (participants || []).filter((el) => el.type.toLowerCase() != "saipem");

		if (trainingParticipants && trainingParticipants.length) {
			trainingParticipants = _sortBy(trainingParticipants, [(p) => p.type?.toLowerCase(), (p) => p.surname?.toLowerCase(), (p) => p.name?.toLowerCase()]);
		}

		const fileDownLoadButtonProps = {
			size: "small",
			className: "bx--export-form",
			iconDescription: "Download Certificate",
			title: "Download Certificate",
			kind: "ghost",
			onDownLoadStart: () => {
				this.setState({
					isLoadingNotificationFile: true,
				});
			},
			onDownLoadEnd: () => {
				this.setState({
					isLoadingNotificationFile: false,
				});
			},
			onError: (error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGCERTIFICATE, apioperation.DOWNLOAD));
			},
		};

		return trainingParticipants == null || trainingParticipants.length == 0 ? (
			<NoRecordsPlaceholder labelText="No Records" colSpan={8} />
		) : (
			trainingParticipants.map((item, index) => (
				<TableRow key={"row_" + item.id}>
					<TableCell key={"cell_type_" + item.id}>{item.type}</TableCell>
					<TableCell key={"cell_surname_" + item.id}>{item.surname}</TableCell>
					<TableCell key={"cell_name_" + item.id}>{item.name}</TableCell>
					<TableCell key={"cell_badgeNumber_" + item.id}>{item.badgeNumber}</TableCell>
					<TableCell key={"cell_position_" + item.id}>{item.position}</TableCell>
					<TableCell key={"cell_knowledgeAssessment_" + item.id}>{item.knowledgeAssessment}</TableCell>
					<TableCell key={"sign-" + item.id} className="tableActions align-center">
						{!this.state.isDisabled && (
							<div>
								{this.state.isEdit && item.signatureAttachment && <Checkmark24 fill="#1A3E4C" aria-label="" />}
								{this.state.isEdit && !item.toSave && (
									<Button onClick={() => this.editParticipantsSign(item.id)} size="small" renderIcon={PaintBrushAlt16} iconDescription="Edit Signature" title="Edit Signature" kind="ghost" />
								)}
							</div>
						)}
					</TableCell>
					<TableCell key={"action-" + item.id} className="tableActions align-center">
						{!this.state.isDisabled && (
							<div>
								{this.showDownloadSingleCert(item) && (
									<Online>
										<FileDownLoadButton
											{...fileDownLoadButtonProps}
											renderIcon={CertificateCheck16}
											apiUrl={`/training/${this.state.idTraining}/participant/${item.id}/certificate`}
											fileName={`Training_Certificate_${this.state.model.code}_${item.surname}_${item.name}.pdf`}
										/>
									</Online>
								)}

								<Button onClick={() => this.editParticipant(item.id)} size="small" renderIcon={Edit16} iconDescription="Edit" title="Edit" kind="ghost" />
								<Button onClick={() => this.confirmDeleteParticipant(item.id)} size="small" renderIcon={Delete16} iconDescription="Delete" title="Delete" kind="ghost" />
							</div>
						)}
					</TableCell>
				</TableRow>
			))
		);
	}

	checkValidHours = (value) => {
		const hours = value ? +value : null
		const decimal = hours ? +hours.toString().split(".").splice(1).join() : 0
		if(!hours  || (decimal !== 0 && decimal !== 5)) return false
		return true
	}

	getTrainingParticipants = () =>{
		api.getAll(`training/${this.state.model.id}/participant`)
		.then((response) =>{
			this.setState({
				model: {...this.state.model, trainingParticipant: response.data}
			});
		})
		.catch((error) => {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGPARTICIPANT, apioperation.GET));
		});
	};

	uploadTemplate = (event) => {
		if (this.state.statusUpload != null) {
			this.setState({
				isImportfunction: true,
				isImportTemplate: true,
				message: [],
			});
			event.preventDefault();
			this.setState(() => ({
				canUpload: true,
				isFileValid: true,
				validationErrorTitle: "",
				validationErrorSubTitle: "",
				statusUpload: "uploading",
			}));
			const formData = new FormData();
			formData.append("FileUploaded", event.target.inputFile.files[0]);

			api.upload(`/training/${this.state.model.id}/trainingParticipant/template`, formData)
				.then((response) => {
					this.setState(() => ({
						canUpload: false,
						isFileValid: true,
						validationErrorTitle: "",
						validationErrorSubTitle: "",
						statusUpload: "complete",
						message: response.data,
						isImportTemplate: false,
						isImportfunction: false,
					}));
					if (response.data && response.data[0] == "Success") {
						showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.TRAININGPARTICIPANTTEMPLATE, apioperation.UPLOAD));
						this.setState(() => ({
							isImportTemplateModalOpen: false,
						}));
					}else{
						this.setState({
							statusUpload: null
						});
					}
					this.getTrainingParticipants();
				})
				.catch((error) => {
					this.setState(() => ({
						canUpload: true,
						isFileValid: false,
						statusUpload: "edit",
						isImportTemplate: false,
						isImportfunction: false,
						importDanger: true,
					}));
					showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGPARTICIPANTTEMPLATE, apioperation.UPLOAD));
				});
		}
	};

	onFileUploadChange = (evt) => {
		this.setState(() => ({ statusUpload: "edit" }));
		if (evt.target.files[0] && evt.target.files[0].size >= 4194304) {
			const nome = evt.target.files[0].name;
			this.fileUploader.clearFiles();
			this.setState(() => ({
				canUpload: false,
				message: [],
				isFileValid: false,
				isImportTemplate: false,
				validationErrorTitle: `${nome} exceeds size limit`,
				validationErrorSubTitle: "4mb max file size. Please select a new file and try again",
			}));
		} else {
			// this.fileUploader.clearFiles();
			this.setState(() => ({
				canUpload: true,
				isFileValid: true,
				validationErrorTitle: "",
				validationErrorSubTitle: "",
				message: [],
			}));
		}
	};

	toggleModalUploadTemplate = (open) => {
		this.fileUploader.clearFiles();
		this.setState({
			isImportTemplateModalOpen: open,
			isImportHC: true,
			message: [],
			statusUpload: null,
			canUpload: false,
			isFileValid: true,
			validationErrorTitle: "",
			validationErrorSubTitle: "",
			__filename: null,
		});
	};

	clearFiles = () => {
		this.fileUploader.clearFiles();
		this.setState(() => ({
			canUpload: false,
			isFileValid: true,
			validationErrorTitle: "",
			validationErrorSubTitle: "",
		}));
	};

	divMessaggImportHC() {
		return (
			<div>
				{!this.state.isImportTemplate ? "" : <Loading />}

				{this.state.message[0] == "Success" ? (
					<div />
				) : (
					<div>
						{this.state.message.map((x) => (
							<div className="bx--row">
								<div className="srv-validation-message"> {x}</div>
							</div>
						))}
					</div>
				)}
			</div>
		);
	}

	renderUploadModal = () => (
		<form onSubmit={this.uploadTemplate}>
			<ComposedModal className="light-modal" open={this.state.isImportTemplateModalOpen} danger="false" onClose={() => false}>
				<ModalHeader className="margin-modal" buttonOnClick={() => this.toggleModalUploadTemplate(false)}>
					<p>Import Training Participants</p>
				</ModalHeader>
				<ModalBody className="margin-modal">
					<div className="bx--file-container">
						<FileUploader
							ref={(node) => (this.fileUploader = node)}
							accept={[".xlsx"]}
							buttonKind="primary"
							buttonLabel="Choose a file"
							filenameStatus={this.state.statusUpload}
							iconDescription="Choose"
							labelTitle="Upload"
							multiple={false}
							name="inputFile"
							onClick={this.clearFiles}
							onChange={this.onFileUploadChange}
						/>
					</div>
					<div>
						{this.state.isImportHC ? this.divMessaggImportHC() : ""}
						{this.state.isImportfunction ? <Loading /> : ""}
					</div>
				</ModalBody>
				<ModalFooter>
					<Button kind="secondary" onClick={() => this.toggleModalUploadTemplate(false)}>
						Cancel
					</Button>
					<Button kind="primary" type={this.state.statusUpload != null ? "submit" : "button"} onClick={this.state.statusUpload != null ? this.clearFiles : null} disabled={!this.state.statusUpload}>
						Upload
					</Button>
				</ModalFooter>
			</ComposedModal>
		</form>
	);

	// RITM0562378
	clearAttachment = () => ({
		id: null, // guid
		fileIdentifier: null,
		name: null,
		contentType: null,
		size: null,
		type: null,
	});

  onUploadFiles = (fileIdentifier, fileName, fileType, size) => {
    const attachment = { ...this.state.attachment };

    attachment.id = uuid();
    attachment.fileIdentifier = fileIdentifier.blobName;
    attachment.name = fileName;
    attachment.contentType = fileType;
    attachment.size = size;
    // attachment.filePath = file.localPath;

    this.setState({
	attachment: this.clearAttachment(),
    });

    try {
	if (attachment == null) return;
	// insert
	const oldattachment = this.state.model.attachments || [];

	const newItem = {
	  id: uuid(), // guid

	  idAttachment: attachment.id, // guid
	  attachment,
	};

	const newattachment = oldattachment.concat([newItem]);
	this.setState({model: {...this.state.model, attachments: newattachment}})
    } catch (error) {
	showNotification.error();
    }
  };

  onRemoveFile = (id) => {
    if (!id) return;
    const statusCopy = { ...this.state.model };
    statusCopy.attachments = statusCopy.attachments.filter((el) => el.id !== id);
    this.setState({model: statusCopy});
  };
// FINE RITM0562378

	render() {
		const appWorksites = this.getWorkSite(this.state.model.startDate, this.state.model.endDate);
		const appProject = this.getPrj(this.state.model.idWorkSite, this.state.model.startDate, this.state.model.endDate);
		const selectedItemCombo = {
			idWorkSite: (appWorksites || []).find((el) => el.id == this.state.model.idWorkSite),
			idProject: (appProject || []).find((el) => el.id == this.state.model.idProject),
			idTrainingData: (this.state.appTrainingData || []).find((el) => el.id == this.state.model.idTrainingData),
			idLanguage: (this.state.appLanguage || []).find((el) => el.id == this.state.model.idLanguage),
			idCountry: (this.state.appCountry || []).find((el) => el.id == this.state.model.idCountry),
			idMethod: (this.state.appMethod || []).find((el) => el.id == this.state.model.idMethod),
			idTrainingAssessmentMethod: (this.state.appAssessmentMethod || []).find((el) => el.id == this.state.model.idTrainingAssessmentMethod),
			idTrainingCenter: (this.state.appTrainingCenters || []).find((el) => el.id == this.state.model.idTrainingCenter)
		};

		const showOtherAssessment = selectedItemCombo.idTrainingAssessmentMethod?.specifyOther;
		this.validator.purgeFields(); //si usa quando ci sono validazioni condizionali tra più campi
		const validations = {
			startDate: this.validator.message("StartDate", this.state.model.startDate, "required"),
			endDate: this.validator.message("EndDate", this.state.model.endDate, "required"),
			endAfterStart: this.validator.message(
				"endAfterStart",
				this.state.model.endDate == null || this.state.model.startDate == null || moment(this.state.model.endDate).isSameOrAfter(moment(this.state.model.startDate), "day"),
				"accepted"
			),
			validityDate: this.validator.message("ValidityDate", this.state.model.validityDate, "required"),
			certificateValidityMonths: this.state.idTraining == null
				? this.validator.message("CertificateValidityPeriod", this.state.model.certificateValidityMonths, "required|gtz")
				: this.validator.message("CertificateValidityPeriod", this.state.model.certificateValidityMonths, "gtz"),
			idTrainingData: this.validator.message("TrainingData", this.state.model.idTrainingData, "required"),
			trainer: this.validator.message("trainer", this.state.model.trainer, "required"),
			idWorkSite: this.validator.message("WorkSite", this.state.model.idWorkSite, "required"),
			idProject: this.validator.message("Project", this.state.model.idProject, "required"),
			//idLanguage: this.validator.message("Language", this.state.model.idLanguage, "required"),
			idMethod: this.validator.message("Method", this.state.model.idMethod, "required"),
			idTrainingAssessmentMethod: this.validator.message("AssessmentMethod", this.state.model.idTrainingAssessmentMethod, "required"),
			specifyOtherAssessmentMethod: showOtherAssessment ? this.validator.message("SpecifyOtherAssessmentMethod", this.state.model.specifyOtherAssessmentMethod, "required") : null,
			certifiedDuration: this.validator.message("Certified Duration", this.state.model.certifiedDuration, "required"),
		};

		const trainingContents = this.state.model.trainingContents ? _sortBy(this.state.model.trainingContents, "createdOn") : [];
		const trainingParticipants = this.state.search
			? (this.state.model.trainingParticipant || []).filter((el) => `${el.surname} ${el.name}`?.toLowerCase().includes(this.state.search?.toLowerCase()))
			: this.state.model.trainingParticipant || [];

		const modalContentProps = {
			key: this.state.keyModalContent,
			title: "Course Contents  (The mention of names and surnames must be done only if strictly necessary. Personal Email Addresses are not allowed)",
			editModel: this.state.idToEditContent ? trainingContents.find((el) => el.id == this.state.idToEditContent) : null,
			isOpenModal: this.state.isOpenModalContent,
			isEditModal: this.state.idToEditContent != null,
			toggleModal: (open) => this.toggleModal(open, "isOpenModalContent"),
			save: this.handleSaveModalContent,
			titleAlert: String.fromCharCode(9888)+" Do Not use Personal Accounts",
					
		};

		const modalParticipantProps = {
			participants: this.state.model.trainingParticipant,
			key: this.state.keyModalParticipant,
			title: "Course Participants",
			editModel: this.state.idToEditParticipant ? trainingParticipants.find((el) => el.id == this.state.idToEditParticipant) : null,
			isOpenModal: this.state.isOpenModalParticipant,
			isEditModal: this.state.idToEditParticipant != null,
			mode: this.state.idToEditParticipant != null ? 2 : 0,
			toggleModal: (open) => this.toggleModal(open, "isOpenModalParticipant"),
			save: this.handleSaveModalParticipant,
			appType: this.state.appInfoOriginator,
		};

		const modalTrainerProps = {
			key: this.state.keyModalTrainer,
			title: "Trainer",
			editModel: this.state.model.trainer,
			isOpenModal: this.state.isOpenModalTrainer,
			isEditModal: this.state.model.trainer != null,
			mode: 2,
			toggleModal: (open) => this.toggleModal(open, "isOpenModalTrainer"),
			save: this.handleSaveModalTrainer,
		};

		const modalSignatureProps = {
			key: this.state.keyModalTrainerSign,
			title: "Trainer Signature",
			editModel: this.state.model.trainer,
			isOpenModal: this.state.isOpenModalTrainerSign,
			toggleModal: (open) => this.toggleModal(open, "isOpenModalTrainerSign"),
			save: this.handleSaveModalTrainerSign,
			idTraining: this.state.idTraining,
		};

		const modalParticipantsSignatureProps = {
			key: this.state.keyModalParticipantsSign,
			title: "Participant Signature",
			editModel: this.state.idToEditParticipantsSign ? trainingParticipants.find((el) => el.id == this.state.idToEditParticipantsSign) : null,
			isOpenModal: this.state.isOpenModalParticipantsSign,
			toggleModal: (open) => this.toggleModal(open, "isOpenModalParticipantsSign"),
			save: this.handleSaveModalParticipantsSign,
			idTraining: this.state.idTraining,
		};

		const fileDownLoadAllProps = {
			apiUrl: `/training/${this.state.idTraining}/certificate`,
			fileName: `Training_Certificates_${this.state.model.code}.zip`,
			onDownLoadStart: () => {
				//RITM0962638 - Download All Certificates Fix
				// if(this.state.model.trainer.signatureAttachment == null){
				// 	throw new Error('Trainer Signature is missing')
				// }
				//End
				this.setState({
					isLoadingNotificationFile: true,
				});
			},
			onDownLoadEnd: () => {
				this.setState({
					isLoadingNotificationFile: false,
				});
			},
			onError: (error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGCERTIFICATE, apioperation.DOWNLOAD));
			},
		};

		const confirmDelProps = () => {
			if (this.state.idToDeleteParticipant) {
				return {
					idToDelete: this.state.idToDeleteParticipant,
					nameItem: "",
					isDeleting: this.state.isDeleting,
					open: this.state.isOpenDeleteModal, //open state
					onCloseConfirm: () => this.toggleModal(false, "isOpenDeleteModal"), //no click
					deleteItem: this.deleteItemParticipant, //yes click fn()
				};
			}

			return {
				idToDelete: this.state.idToDeleteContent,
				nameItem: "",
				isDeleting: this.state.isDeleting,
				open: this.state.isOpenDeleteModal, //open state
				onCloseConfirm: () => this.toggleModal(false, "isOpenDeleteModal"), //no click
				deleteItem: this.deleteItemContent, //yes click fn()
			};
		};

		const showModalSignature = this.state.isEdit && this.state.model.trainer != null;

		return (
			<AppContext.Consumer>
				{({ user }) => (
					<>
						<PageBreadCrumb
							linkTo={!this.state.isEdit ? "/training" : "/training?isBack"}
							linkText="Trainings"
							titleLeft={this.state.isEdit ? "Edit Training" : "New Training"}
							titleCenter={this.state.model.code && "ID: " + this.state.model.code}
							titleRight={this.state.model.status}
							batchActions={this.state.isEdit ? this.getStatusActions(user) : null}
							showButtonHistory={this.state.isEdit ? this.showButtonHistory() : null}
						/>
						<div className="mainContainer">
							<Loading active={this.state.isLoadingNotificationFile} withOverlay />
							<div className="bx--grid content full-width">
								<ConfirmAlertCustom {...confirmDelProps()} />
								{this.renderUploadModal()}
								{this.showLoading()}
								<WFActionModal
									show={this.state.isApprovalModalOpen}
									title={`${this.state.approvalModalAction} Training`}
									action={this.state.approvalModalAction}
									withApprover={this.state.withApprover}
									approver={this.state.approver}
									approverRole={this.state.approverRole}
									approverOptions={this.state.approvers}
									isLoadingOperation={this.state.isLoadingWFOperation}
									onApproverSelect={this.handleApproverSelect}
									isLoadingOptions={this.state.isLoadingApproverOptions}
									onCancel={this.handleCloseApprovalModal}
									onConfirm={this.handleConfirmApprovalModal}
									onApprovalNotesChange={this.handleApprovalNotesChange}
									approvalNotes={this.state.approvalNotes}
									approvalNotesRequired={this.state.approvalNotesRequired}
									validationMessages={this.state.approvalValidationMessages}
								/>

								{this.state.isEdit && <HistoryTable entityId={this.state.idTraining} isOpenModal={this.state.isHistoryModalOpen} onClose={() => this.closeModalHistory()} />}
								<form
									autoComplete="off"
									onSubmit={(e) => {
										e.preventDefault();
									}}
								>
									<div className=" bx--row">
										<div className="bx--col-lg-12 bx--tab-container bx--tab--conteiner-training">
											<ScrollingProvider key="scroll_0">
												<div className="bx--row">
													<div className="padding-progress-indicator-vertical hidden-box">
														<Menu>
															<Item section="sec1">Training</Item>
															<Item section="sec2">Course Contents</Item>
															<Item section="sec3">Training Participant</Item>

															{/* RITM0562378 */}
															<Item section="sec4">Attachment</Item>
															{/* FINE RITM0562378 */}

														</Menu>
													</div>
													<div className="bx--col-lg-10 bx--col-md-10 margin-progress-indicator-vertical">
														<Section id="sec1" className="section--title">
															<div className="title-pagination-description">
																<h3 className="title--medium">Training</h3>
															</div>

															<div className="bx--row">
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup key="startDate" legendText="Start Date*">
																		<DateTimePicker
																			value={this.state.model.startDate}
																			type="date"
																			placeholder={DateFormat}
																			name="startDate"
																			alt="model"
																			invalid={validations.startDate != null}
																			onChange={this.handleChangeDate}
																			disabled={this.state.isDisabled}
																		/>
																		{validations.startDate}
																	</FormGroup>
																</div>
																<div className="bx--col-lg-6 bx--col-md-4 ">
																	<FormGroup key="endDate" legendText="End Date*">
																		<DateTimePicker
																			value={this.state.model.endDate}
																			type="date"
																			placeholder={DateFormat}
																			name="endDate"
																			alt="model"
																			invalid={validations.endDate != null}
																			onChange={this.handleChangeDate}
																			disabled={this.state.isDisabled}
																		/>
																		{validations.endDate}
																		{validations.endAfterStart && <div className="srv-validation-message">The end date field must be after start date field</div>}
																	</FormGroup>
																</div>
															</div>
															<div className="bx--row">
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup legendText="Worksite*">
																		<ComboBox
																			id="idWorkSite"
																			key={`idWorkSite${selectedItemCombo.idWorkSite}`}
																			placeholder="Select"
																			name="idWorkSite"
																			alt="model"
																			onChange={this.handleChangeCombo}
																			itemToString={(item) => (item ? item.name : "")}
																			initialSelectedItem={selectedItemCombo.idWorkSite}
																			items={appWorksites}
																			disabled={appWorksites == null || this.state.isDisabled || appWorksites.length == 0}
																			invalid={validations.idWorkSite != null}
																		/>
																		{validations.idWorkSite}
																	</FormGroup>
																</div>
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup legendText="Project*">
																		<ComboBox
																			id="idProject"
																			key={`idProject${selectedItemCombo.idProject}`}
																			placeholder="Select"
																			name="idProject"
																			alt="model"
																			onChange={this.handleChangeCombo}
																			itemToString={(item) => (item ? item.name : "")}
																			initialSelectedItem={selectedItemCombo.idProject}
																			items={appProject}
																			disabled={appProject == null || this.state.isDisabled || appProject.length == 0}
																			invalid={validations.idProject != null}
																		/>
																		{validations.idProject}
																	</FormGroup>
																</div>
															</div>

															<div className="bx--row">
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup legendText="Training Title And Code*">
																		<ComboBox
																			id="idTrainingData"
																			key={`idTrainingData${this.state.model.idTrainingData}`}
																			placeholder="Select"
																			name="idTrainingData"
																			alt="model"
																			onChange={this.handleChangeCombo}
																			itemToString={(item) => (item ? item.courseCode : "")}
																			// initialSelectedItem={selectedItemCombo.idTrainingData}
																			selectedItem={selectedItemCombo.idTrainingData}
																			items={this.returnValidTrainingData(this.state.appTrainingData) ?? []}
																			disabled={this.state.appTrainingData == null || this.state.isDisabled || !this.state.model.startDate}
																			invalid={validations.idTrainingData != null}
																		/>
																		{validations.idTrainingData}
																	</FormGroup>
																</div>
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup legendText="Training Delivery Language">
																		<ComboBox
																			id="idLanguage"
																			key={`idLanguage${this.state.model.idLanguage}`}
																			placeholder="Select"
																			name="idLanguage"
																			alt="model"
																			onChange={this.handleChangeCombo}
																			itemToString={(item) => (item ? item.name : "")}
																			initialSelectedItem={selectedItemCombo.idLanguage}
																			items={this.state.appLanguage}
																			disabled={this.state.appLanguage == null || this.state.isDisabled}
																			//invalid={validations.idLanguage != null}
																		/>

																	</FormGroup>
																</div>
															</div>
															<div className="bx--row">
																<div className="bx--col-lg-3 bx--col-md-4">
																	<FormGroup legendText="Standard Duration (hours)">
																		<TextInput
																			id="Duration"
																			value={(this.state.model.info && this.state.model.info.duration) || ""}
																			type="text"
																			hideLabel={true}
																			labelText=""
																			disabled={true}
																			className="bx--text-input disable-text"
																		/>
																	</FormGroup>
																</div>
																<div className="bx--col-lg-3 bx--col-md-4">
																	<FormGroup legendText="Certified Duration (hours)*">
																		<TextInput
																			id="certifiedDuration"
																			name="certifiedDuration"
																			value={(this.state.model && this.state.model.certifiedDuration) || ""}
																			labelText=""
																			disabled={(this.state.model.info != null && this.state.model.info.duration > 0) || this.state.isDisabled}
																			alt="model"
																			onChange={this.handleChangeModel}
																			type="number"
																			hideLabel={true}
																			invalid={validations.certifiedDuration != null || this.state.invalidCertifiedDuration}
																		/>
																	</FormGroup>
																</div>
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup legendText="MyLearning Code">
																		<TextInput
																			id="PeopleLearningCode"
																			value={(this.state.model.info && this.state.model.info.peopleLearnigCode) || ""}
																			type="text"
																			hideLabel={true}
																			labelText=""
																			disabled={true}
																			className="bx--text-input disable-text"
																		/>
																	</FormGroup>
																</div>
															</div>
															<div className="bx--row">
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup legendText="Country">
																		<ComboBox
																			id="idCountry"
																			key={`idCountry${this.state.model.idCountry}`}
																			placeholder="Select"
																			name="idCountry"
																			alt="model"
																			onChange={this.handleChangeCombo}
																			itemToString={(item) => (item ? item.name : "")}
																			initialSelectedItem={selectedItemCombo.idCountry}
																			items={this.state.appCountry}
																			disabled={this.state.appCountry == null || this.state.isDisabled}
																		/>
																	</FormGroup>
																</div>
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup legendText="Training Centre (If Applicable)">
																		<ComboBox
																			id="idTrainingCenter"
																			key={`idTrainingCenter${this.state.model.idTrainingCenter}`}
																			placeholder="Select"
																			name="idTrainingCenter"
																			alt="model"
																			onChange={this.handleChangeCombo}
																			itemToString={(item) => (item ? item.name : "")}
																			initialSelectedItem={selectedItemCombo.idTrainingCenter}
																			items={this.state.appTrainingCenters}
																			disabled={this.state.appTrainingCenters == null || this.state.isDisabled}
                                    />
                                  </FormGroup>
																</div>
															</div>
															<div className="bx--row">
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup key="validityDate" legendText="Certificate Validity Period (Months) *">
																		<TextInput
                                      className="cell--item"
																			name="certificateValidityMonths"
																			alt="model"
                                      value={this.state.model.certificateValidityMonths}
                                      onChange={this.handleChangeCertificateValidityPeriod}
                                      type="number"
                                      min="0"
                                      invalid={validations.certificateValidityMonths != null}
                                    />
																		{validations.certificateValidityMonths}
																	</FormGroup>
																</div>

																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup key="validityDate" legendText="Certificate Validity Date">
																		<DatePicker
																			datePickerType="simple"
                                      value={moment(this.state.model.validityDate).format("DD/MM/YYYY")}
                                      className="disable-text"
																		>
																			<DatePickerInput
																				id="certificate-validity-date-input"
																				placeholder=""
																				disabled
                                      />
																		</DatePicker>
																	</FormGroup>
                                </div>
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup legendText="Training Methods*">
																		<ComboBox
																			id="idMethod"
																			key={`idMethod${this.state.model.idMethod}`}
																			placeholder="Select"
																			name="idMethod"
																			alt="model"
																			onChange={this.handleChangeCombo}
																			itemToString={(item) => (item ? item.name : "")}
																			initialSelectedItem={selectedItemCombo.idMethod}
																			items={this.state.appMethod}
																			disabled={this.state.appMethod == null || this.state.isDisabled}
																			invalid={validations.idMethod != null}
																		/>
																		{validations.idMethod}
																	</FormGroup>
																</div>
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup legendText="Training Assessment Methods*">
																		<ComboBox
																			id="idTrainingAssessmentMethod"
																			key={`idTrainingAssessmentMethod${this.state.model.idTrainingAssessmentMethod}`}
																			placeholder="Select"
																			name="idTrainingAssessmentMethod"
																			alt="model"
																			onChange={this.handleChangeCombo}
																			itemToString={(item) => (item ? item.name : "")}
																			initialSelectedItem={selectedItemCombo.idTrainingAssessmentMethod}
																			items={this.state.appAssessmentMethod}
																			disabled={this.state.appAssessmentMethod == null || this.state.isDisabled}
																			invalid={validations.idTrainingAssessmentMethod != null}
																		/>
																		{validations.idTrainingAssessmentMethod}
																	</FormGroup>
																</div>
																{showOtherAssessment && (
																	<div className="bx--col-lg-6 bx--col-md-4">
																		<FormGroup legendText="Specify other*">
																			<TextInput
																				id="specifyOtherAssessmentMethod"
																				name="specifyOtherAssessmentMethod"
																				alt="model"
																				placeholder="Specify other..."
																				value={this.state.model.specifyOtherAssessmentMethod || ""}
																				onChange={this.handleChangeModel}
																				type="text"
																				hideLabel={true}
																				labelText=""
																				disabled={this.state.isDisabled}
																				invalid={validations.specifyOtherAssessmentMethod != null}
																			/>
																			{validations.specifyOtherAssessmentMethod}
																		</FormGroup>
																	</div>
																)}
															</div>
															{/* <div className="bx--row section--title">
                                                            <div>
                                                                <h3 className="title--medium--expressive">Trainer</h3>
                                                            </div>
                                                        </div> */}
															<div className="bx--row row-content">
																<div className="bx--col-lg-12 bx--col-md-12">
																	<TableToolbar>
																		<h3 className="title--medium max-width"></h3>
																		{!this.state.isDisabled && (
																			<Button
																				onClick={() => {
																					this.editTrainer();
																				}}
																				renderIcon={Edit16}
																			>
																				Edit Trainer
																			</Button>
																		)}
																	</TableToolbar>
																	<FormGroup legendText="">
																		<StructuredListWrapper className="description-table">
																			<StructuredListHead>
																				<StructuredListRow head>
																					<StructuredListCell head>Trainer Type</StructuredListCell>
																					<StructuredListCell head>Trainer Surname</StructuredListCell>
																					<StructuredListCell head>Trainer Name</StructuredListCell>
																					<StructuredListCell head>Signature</StructuredListCell>
																					<StructuredListCell head>Actions</StructuredListCell>
																				</StructuredListRow>
																			</StructuredListHead>
																			<StructuredListBody>
																				<StructuredListRow>
																					<StructuredListCell>{this.state.model.trainer && this.state.model.trainer.type}</StructuredListCell>
																					<StructuredListCell>{this.state.model.trainer && this.state.model.trainer.surname}</StructuredListCell>
																					<StructuredListCell>{this.state.model.trainer && this.state.model.trainer.name}</StructuredListCell>
																					<StructuredListCell className="signature-trainer">
																						{showModalSignature && this.state.model.trainer && this.state.model.trainer.signatureAttachment && (
																							<Checkmark24 fill="#1A3E4C" aria-label="" />
																						)}
																					</StructuredListCell>
																					<StructuredListCell className="signature-trainer">
																						{showModalSignature && !this.state.isDisabled && (
																							<Button
																								onClick={() => this.editTrainerSign()}
																								size="small"
																								className="bx--btn--icon-only"
																								renderIcon={PaintBrushAlt16}
																								iconDescription="Edit Signature"
																								title="Edit Signature"
																								kind="ghost"
																							/>
																						)}
																					</StructuredListCell>
																				</StructuredListRow>
																			</StructuredListBody>
																		</StructuredListWrapper>
																	</FormGroup>
																	<div>{validations.trainer}</div>
																</div>
															</div>
															<ModalTrainer {...modalTrainerProps} />
															{showModalSignature && <ModalSignature {...modalSignatureProps} />}
															<div className="error-validation-message"></div>
														</Section>
														<Section id="sec2">
															<div className="bx--row section--title">
																<div>
																	<h3 className="title--medium--expressive">Course Contents</h3>
																</div>
															</div>

															<div className="bx--row">
																<div className="bx--col-lg-12">
																	<TableToolbar>
																		<h3 className="title--medium max-width"></h3>
																		{!this.state.isDisabled && (
																			<Button
																				onClick={() => {
																					this.addContent();
																				}}
																				renderIcon={Add16}
																			>
																				Add new
																			</Button>
																		)}
																	</TableToolbar>
																	<TableContainer className="bx--grid--full-width">
																		<Table>
																			<TableHead className="colorgray">
																				<TableRow>
																					<TableHeader>Content</TableHeader>
																					<TableHeader className="align-center">Actions</TableHeader>
																				</TableRow>
																			</TableHead>
																			<TableBody>
																				{trainingContents == null || trainingContents.length == 0 ? (
																					<NoRecordsPlaceholder labelText="No Records" colSpan={2} />
																				) : (
																					trainingContents.map((item, index) => (
																						<TableRow key={"row_" + item.id}>
																							<TableCell key={"cell_content_" + item.id}>{item.content && item.content.substr(0, 200)}</TableCell>
																							<TableCell key={"action-" + item.id} className="tableActions align-center">
																								{!this.state.isDisabled && (
																									<div>
																										<Button
																											onClick={() => this.editContent(item.id)}
																											size="small"
																											renderIcon={Edit16}
																											iconDescription="Edit"
																											title="Edit"
																											kind="ghost"
																										/>
																										<Button
																											onClick={() => this.confirmDeleteContent(item.id)}
																											size="small"
																											renderIcon={Delete16}
																											iconDescription="Delete"
																											title="Delete"
																											kind="ghost"
																										/>
																									</div>
																								)}
																							</TableCell>
																						</TableRow>
																					))
																				)}
																			</TableBody>
																		</Table>
																	</TableContainer>
																</div>
															</div>
															<ModalContent {...modalContentProps} />
															<div className="error-validation-message"></div>
														</Section>

														<Section id="sec3">
															<div className="bx--row section--title">
																<div>
																	<h3 className="title--medium--expressive">Training Participant</h3>
																</div>
															</div>

															<div className="bx--row">
																<div className="bx--col-lg-12">
																	<TableToolbar>
																		<Search
																			className=""
																			light
																			name=""
																			labelText="Search"
																			placeHolderText="Search"
																			id="search-1"
																			value={this.state.search || ""}
																			onChange={this.handleInputChange}
																		/>
																		{this.state.isEdit && (
																			<Online>
																				<FileDownLoadButton {...fileDownLoadAllProps} renderIcon={CertificateCheck16}>
																					Download All Certificates
																				</FileDownLoadButton>
																			</Online>
																		)}
																		<FileDownLoadButton
																			className="btn-notext"
																			onError={(error) => {
																				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAINING, apioperation.DOWNLOAD));
																			}}
																			renderIcon={Download16}
																			size="small"
																			title="Download Training Participant"
																			apiUrl={`/training/${this.state.model.id}/template`}
																			fileName="TrainingPartecipantTemplate.xlsx"
																			onDownLoadStart={() => {
																				this.setState({
																					downloadTemplateLoading: true,
																				});
																			}}
																			onDownLoadEnd={() => {
																				this.setState({
																					downloadTemplateLoading: false,
																				});
																			}}
																		>
																			{!this.state.downloadTemplateLoading ? '' : <Loading />}
																		</FileDownLoadButton>
																		{/* RITM0992772 - Participants Without Assessment For Submitted Training Fix */}
																		{/* {this.state.isEdit && (
																		<Button
																			className="btn-notext"
																			renderIcon={Export16}
																			size="small"
																			title="Import Training Participant"
																			onClick={() => this.toggleModalUploadTemplate(true)}
																			/>
																		)} */}
																		{this.state.isEdit && !this.state.isDisabled && (
																		<Button
																			className="btn-notext"
																			renderIcon={Export16}
																			size="small"
																			title="Import Training Participant"
																			onClick={() => this.toggleModalUploadTemplate(true)}
																			/>
																		)}
																		{/* End */}

																		{!this.state.isDisabled && (
																			<Button
																				onClick={() => {
																					this.addParticipant();
																				}}
																				renderIcon={Add16}
																			>
																				Add new
																			</Button>
																		)}
																	</TableToolbar>
																	<TableContainer className="bx--grid--full-width">
																		<Table>
																			<TableHead className="colorgray">
																				<TableRow>
																					<TableHeader>Type</TableHeader>
																					<TableHeader>Surname</TableHeader>
																					<TableHeader>Name</TableHeader>
																					<TableHeader>Badge Number / Company</TableHeader>
																					<TableHeader>Job Position</TableHeader>
																					<TableHeader>Assessment</TableHeader>
																					<TableHeader className="align-center">Signature</TableHeader>
																					<TableHeader className="align-center">Actions</TableHeader>
																				</TableRow>
																			</TableHead>
																			<TableBody>
																				<TableRow key="saipem" className="table-subtitle">
																					<TableCell colSpan={8}>SAIPEM PERSONNEL</TableCell>
																				</TableRow>
																				{this.renderParticipants(true, trainingParticipants)}
																			</TableBody>

																			<TableBody>
																				<TableRow key="sub" className="table-subtitle">
																					<TableCell colSpan={8}>(SUB) CONTRACTOR PERSONNEL / PARTNERS</TableCell>
																				</TableRow>
																				{this.renderParticipants(false, trainingParticipants)}
																			</TableBody>
																		</Table>
																	</TableContainer>
																</div>
															</div>
															<ModalParticipant {...modalParticipantProps} />
															{modalParticipantsSignatureProps.editModel && <ModalSignatureParticipant {...modalParticipantsSignatureProps} />}
															<div className="error-validation-message"></div>
														</Section>

														{/* RITM0562378 */}
														<Section id="sec4" style={{margin: "40px 0px"}}>
															<div className="bx--row section--title">
																<div>
																	<h3 className="title--medium--expressive">Attachments</h3>
																</div>
															</div>

															<AttachmentTable
																storagePath="training"
																acceptedFile={[".pdf"]}
																model={this.state.model}
																items={this.state.model?.attachments}
																apiDownloadUrl={`/training/${this.state.idTraining}/attachment/`}
																onUploadFIle={this.onUploadFiles}
																onDeleteFile={this.onRemoveFile}
																maxUploadDocument={1}
																customMainDescription={TrainingAttachmentTableMainDescription}
																customDescription={attachmentTablePrivacyText}
																isDisabled={this.state.isDisabled}
															/>
														</Section>
														{/* FINE RITM0562378 */}

													</div>
												</div>
												<div className="bx--row">
													<Button onClick={() => this.cancel()} className="bx--col bx--btn--max-width" size="default" kind="secondary">
														Cancel
													</Button>
													<Button onClick={() => this.saveTraining()} disabled={this.state.isDisabled} className="bx--col bx--btn--max-width" size="default" kind="primary">
														Save
													</Button>
													<Button onClick={() => window.print()} disabled={this.state.isDisabled} className="bx--col bx--btn--max-width" size="default" kind="secondary">
														Print
													</Button>
												</div>
											</ScrollingProvider>
										</div>
									</div>
								</form>
							</div>
						</div>
					</>
				)}
			</AppContext.Consumer>
		);
	}
}

NewTraining.contextType = AppContext;
